export class AccionistaPep {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            pep: {
                value: null,
                header: 'Es usted un PEP:',
                required: 'Seleccione una opción'
            },
            esta_relacionado_pep: {
                value: null,
                header: 'Está relacionado con un PEP:',
                required: 'Seleccione una opción'
            },
            relacion: {
                value: '',
                header: 'Relación o vínculo:',
                required: 'Relación o vínculo es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            nombre_pep: {
                value: '',
                header: 'Nombre del PEP',
                table: true,
                tablePorTipo: {
                    FRM_TOYOTA: false,
                    FRM_DIFARE: false,
                }
            },
            cargo_pep: {
                value: '',
                header: 'Cargo',
                headerPorTipo: {
                    FRM_TOYOTA: 'Cargo:',
                    FRM_DIFARE: 'Cargo:',
                }
            },
            institucion_trabaja_pep: {
                value: '',
                header: 'Institución donde trabaja o trabajó',
                headerPorTipo: {
                    FRM_TOYOTA: 'Institución donde trabaja o trabajó:',
                    FRM_DIFARE: 'Institución donde trabaja o trabajó:',
                },
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Institución es reqeurido'
            },
            fecha_nombramiento_pep: {
                value: new Date(),
                header: 'Fecha del nombramiento de la designación (día/mes/año):',
                headerPorTipo: {
                    FRM_TOYOTA: 'Fecha del nombramiento:',
                    FRM_DIFARE: 'Fecha del nombramiento:',
                },
                required: 'Fecha es requerido'
            },
            fecha_dejo_pep: {
                value: null,
                header: 'Fecha en que dejó de ser PEP, de no estar en funciones (día/mes/año):',
                headerPorTipo: {
                    FRM_TOYOTA: 'Fecha de culminación:',
                    FRM_DIFARE: 'Fecha de culminación:',
                },
                required: false
            },
            relacion_vinculo_pep: {
                value: '',
                header: 'Relación o vínculo:',
                required: 'Relación es requerida',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            nombre_vinculo_pep: {
                value: '',
                header: 'Nombre del PEP:',
                required: 'Nombres es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            cargo_vinculo_pep: {
                value: '',
                header: 'Cargo:',
                required: 'Cargo es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            institucion_vinculo_pep: {
                value: '',
                header: 'Institución donde trabaja o trabajó:',
                required: 'Institución es requerido',
                maxLength: 'Máximo 150 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 150,
                min: 4
            },
            fecha_vinculo_pep: {
                value: new Date(),
                header: 'Fecha del nombramiento:',
                required: 'Fecha es requerido'
            },
            fecha_culminacion_pep: {
                value: null,
                header: 'Fecha de culminación:',
                required: false
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
    strPep = <><p>PEP: Son todas las personas naturales, nacionales o extranjeras, que desempeñan o han desempeñado funciones o cargos públicos destacados en el Ecuador o en el extranjero,
        o funciones prominentes en una organización internacional, conforme a los lineamientos establecidos por la Unidad de Análisis Financiero y Económico (UAFE), y la Superintendencia de
        Compañías, Valores y Seguros.<br /> Familiares y Personas Relacionadas de las Personas Expuestas Políticamente: Se consideran como personas expuestas políticamente (PEP) a los familiares
        de las Personas Expuestas Políticamente (PEP), sean estos los cónyuges o personas unidas bajo el régimen de unión de hecho, familiares hasta el segundo grado de consanguinidad o primero
        de afinidad; y el o los colaborador (es) directo (s) esto es la (s) persona (s) natural (es) con las cuales una Persona Políticamente Expuesta (PEP), se encuentre asociada o vinculada
        societariamente, o mantenga otro tipo de relaciones empresariales, comerciales o labores estrechas.</p>
        <p>Los funcionarios públicos de menor grado que no estén comprendidos dentro del nivel jerárquico superior, se excluyen de la definición de PEP; con excepción de aquellos que ejerzan
        la representación de un PEP o cumplan funciones en su nombre, para lo cual se realizará la correspondiente evaluación de riesgo.</p></>;
}
